<template>
<div>

    <v-card>
        <v-toolbar dark flat color="error">
            <v-toolbar-title>Danger Zone</v-toolbar-title>
        </v-toolbar>
        <v-card-text pa-5>
            <p class="title pa-5">To delete this class you must first clear the roster of all enrolled and waitlisted students. After clearing the roster, type in your password and confirm.</p>
            <v-form>
                <v-layout row px-5>
                    <v-flex xs6>
                        <v-text-field v-model="password" label="Password" type="password" name="password" v-validate="'validpw'" :color="validpw ? 'green' : 'initial'" :append-icon="validpw ? 'check_circle' : ''" prepend-inner-icon="lock" box>
                        </v-text-field>
                        <div class="error--text text-xs-center">{{ errors.first('password') }}</div>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs6>
                        <v-layout>
                            <v-spacer></v-spacer>
                            <v-btn color="red" @click="confirmDialog = true" :dark="validpw" :disabled="!validpw">DELETE</v-btn>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-card-text>
    </v-card>

    <v-dialog persistent v-model="confirmDialog" max-width="700px">
        <v-card>
            <v-card-text>
                <v-alert class="title" :value="true" type="error">
                    Are you sure you want to delete {{ course.name }}, section: {{ course.section }}?
                </v-alert>
            </v-card-text>
            <v-card-actions class="mr-2 pb-3">
                <v-spacer></v-spacer>
                <v-btn small color="primary" @click="confirmDialog = false">No</v-btn>
                <v-btn small color="primary" @click="deleteCourse">Yes</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="errorAlert.active" max-width="700px">
        <v-card>
            <v-card-text>
                <v-alert class="title" :value="true" type="error">{{ errorAlert.message }}</v-alert>
            </v-card-text>
            <v-card-actions>
                <v-btn flat color="primary" @click="errorAlert.active = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog persistent v-model="successAlert" max-width="700px">
        <v-card>
            <v-card-text>
                <v-alert class="title" :value="true" type="success">{{ course.name }} has successfully been deleted.</v-alert>
            </v-card-text>
            <v-card-actions>
                <v-btn flat color="primary" @click="$router.go('-1')">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import {
    Validator
} from 'vee-validate'
import axios from 'axios'

export default {
    props: {
        course: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            password: '',
            validpw: false,
            confirmDialog: false,
            successAlert: false,
            errorAlert: {
                active: false,
                message: '',
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.auth.user
        }
    },
    watch: {
        // vee-validate doesn't trigger when clearing out input
        'password'(value) {
            if (value === '') this.validpw = false
        }
    },
    mounted() {
        const validPassword = (value, args) => {
            return axios.post('/api/admin/validate/password', {
                email: this.user.email,
                password: value
            }).then((response) => {
                this.validpw = response.data.valid ? true : false
                return {
                    valid: true,
                    data: {
                        message: ''
                    }
                }
            }).catch((errors) => {
                this.validpw = false
                return {
                    valid: false,
                    data: {
                        message: errors.response.statusText
                    }
                }
            })
        }
        Validator.extend("validpw", {
            validate: validPassword,
            getMessage: (field, params, data) => data.message
        });
    },
    methods: {
        deleteCourse() {
            this.confirmDialog = false
            this.$store.dispatch('deleteCourse', this.course.id)
                .then(() => {
                    this.successAlert = true
                })
                .catch((e) => {
                    this.errorAlert.active = true
                    if (e.response.status === 400) {
                        this.errorAlert.message = `${this.course.name} still has students either enrolled or waitlisted in the class. You must clear the roster in order to delete the class.`
                    } else {
                        this.errorAlert.message = 'Whoops looks like something went wrong! (in DeleteForm.vue)'
                    }
                })
        }
    }
}
</script>
